import * as React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import { GatsbyImage } from 'gatsby-plugin-image'
import useCDNImage from '../../hooks/useCDNImage'
import { srcSizes } from '../../common/gatsbyImageData'

const ImageMosaicSection = ({ section }) => {
  const image_top_left = useCDNImage(
    section.images_top_left,
    {},
    srcSizes,
    '(min-width: 768px) 64rem, 100vw'
  )

  const image_top_center = useCDNImage(
    section.images_top_center,
    {},
    srcSizes,
    '(min-width: 768px) 32rem, 50vw'
  )

  const image_top_right = useCDNImage(
    section.images_top_right,
    {},
    srcSizes,
    '(min-width: 768px) 32rem, 50vw'
  )

  const image_bottom_left = useCDNImage(
    section.images_bottom_left,
    {},
    srcSizes,
    '(min-width: 768px) 32rem, 50vw'
  )

  const image_bottom_center = useCDNImage(
    section.images_bottom_center,
    {},
    srcSizes,
    '(min-width: 768px) 32rem, 50vw'
  )

  const image_bottom_right = useCDNImage(
    section.images_bottom_right,
    {},
    srcSizes,
    '(min-width: 768px) 64rem, 100vw'
  )

  return (
    <section
      className={
        'flex w-full flex-wrap lg:grid lg:grid-cols-[1fr_1fr_1fr_1fr] lg:grid-rows-[1fr_1fr_1fr] max-w-[1366px] mx-auto'
      }
    >
      <div
        className={
          'order-7 lg:col-span-2 lg:w-full lg:h-full lg:col-start-1 lg:row-start-1 aspect-[2/1] overflow-hidden'
        }
      >
        <GatsbyImage
          image={image_top_left?.gatsbyImageData}
          alt={'Gray and Sons Jewelers and Watch Repairs Miami Beach'}
          sizes={'(min-width: 768px) 64rem, 100vw'}
          imgStyle={{ objectFit: 'cover' }}
          className={'h-full w-full'}
        />
      </div>
      <div
        className={
          'order-1 w-1/2  lg:w-full lg:h-full  lg:col-start-3 lg:row-start-1 aspect-square overflow-hidden'
        }
      >
        <GatsbyImage
          className={'h-full w-full'}
          image={image_top_center?.gatsbyImageData}
          alt={'Used Cartier Patek Philippe Audemars Piguet Watches'}
          sizes={'(min-width: 768px) 32rem, 50vw'}
          imgStyle={{ objectFit: 'cover' }}
        />
      </div>
      <div
        className={
          'order-4 w-1/2 lg:col-start-4  lg:row-span-2 lg:row-start-1 lg:w-full lg:h-full  aspect-[1/2] overflow-hidden h-full'
        }
      >
        <GatsbyImage
          className={'h-full w-full'}
          image={image_top_right?.gatsbyImageData}
          alt={'Diamond Estate Jewelry Discount'}
          sizes={'(min-width: 768px) 32rem, 50vw'}
          imgStyle={{ objectFit: 'cover' }}
        />
      </div>
      <div
        className={
          'order-5 w-1/2 lg:col-start-1 lg:row-span-2 lg:row-start-2 lg:w-full lg:h-full aspect-[1/2] overflow-hidden h-full'
        }
      >
        <GatsbyImage
          className={'h-full w-full'}
          image={image_bottom_left?.gatsbyImageData}
          alt={'Certified Pre-Owned Rolex Watches'}
          sizes={'(min-width: 768px) 32rem, 50vw'}
          imgStyle={{ objectFit: 'cover' }}
        />
      </div>
      <div
        className={
          'order-2 w-1/2 lg:col-start-2 lg:row-start-3 lg:w-full lg:h-full  aspect-square overflow-hidden'
        }
      >
        <GatsbyImage
          className={'h-full w-full'}
          image={image_bottom_center?.gatsbyImageData}
          alt={'Wedding or Engagement Ring'}
          sizes={'(min-width: 768px) 32rem, 50vw'}
          imgStyle={{ objectFit: 'cover' }}
        />
      </div>
      <div
        className={
          ' lg:w-full lg:h-full order-0 lg:col-span-2 lg:col-start-3 lg:row-start-3 aspect-[2/1] overflow-hidden'
        }
      >
        <GatsbyImage
          image={image_bottom_right?.gatsbyImageData}
          alt={'Used Rolex Luxury Watches for Sale'}
          className={'aspect-video h-full w-full'}
          sizes={'(min-width: 768px) 64rem, 100vw'}
          imgStyle={{ objectFit: 'cover' }}
        />
      </div>
      <div
        className={
          ' w-full order-3 self-center py-8 text-center text-xl leading-relaxed lg:col-span-2 lg:col-start-2 lg:row-start-2 md:aspect-video flex flex-col items-center justify-center aspect-[2/1] overflow-hidden'
        }
        dangerouslySetInnerHTML={{ __html: section.content }}
      />
    </section>
  )
}

ImageMosaicSection.propTypes = {
  section: PropTypes.shape({
    content: PropTypes.string.isRequired,
    images_top_left: PropTypes.object.isRequired,
    images_top_center: PropTypes.object.isRequired,
    images_top_right: PropTypes.object.isRequired,
    images_bottom_left: PropTypes.object.isRequired,
    images_bottom_center: PropTypes.object.isRequired,
    images_bottom_right: PropTypes.object.isRequired,
  }),
  className: PropTypes.string,
}

export const query = graphql`
  fragment ImageMosaicSection on STRAPI__COMPONENT_SECTION_IMAGE_MOSAIC {
    id
    strapi_component
    content
    # fields {
    #   contentImg
    # }
    images_top_left {
      gatsbyImageDataMock
    }
    images_top_center {
      gatsbyImageDataMock
    }
    images_top_right {
      gatsbyImageDataMock
    }
    images_bottom_left {
      gatsbyImageDataMock
    }
    images_bottom_center {
      gatsbyImageDataMock
    }
    images_bottom_right {
      gatsbyImageDataMock
    }
  }
`

export default ImageMosaicSection
